'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./Fieldset.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Fieldset = function Fieldset(props) {
    var disabled = props.disabled,
        form = props.form,
        name = props.name,
        legend = props.legend;

    return _react2.default.createElement(
        'fieldset',
        { className: 'Fieldset ' + name, disabled: disabled, form: form, name: name },
        legend ? _react2.default.createElement(
            'legend',
            null,
            legend
        ) : null,
        _react2.default.createElement(
            'div',
            { className: 'fieldset-contents' },
            props.children
        )
    );
};

// Styles
// Lib


Fieldset.propTypes = {
    disabled: _propTypes2.default.bool,
    form: _propTypes2.default.string,
    name: _propTypes2.default.string,
    legend: _propTypes2.default.string,
    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
};

exports.default = Fieldset;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/form/Fieldset.js
// module id = 698
// module chunks = 0